<script>
    import findingService from "../../../finding/v2-service.js";
    import vulnerabilityService from "../../../vulnerability/service.js";
    import BreadCrumNav from "../../../../components/breadcrum-nav.svelte";
    import PropertiesList from "../../../../components/properties-list.svelte";
    import PropValueRow from "../../../../components/powerTable/prop-value-row.svelte";
    import PropKindRow from "../../../../components/powerTable/prop-kind-row.svelte";
    import { ipAdressesCustomComparator } from "../../../../js/utils.js";
    import CountByPropValue from "../../_components/count-by-prop-value.svelte";
    import tagService from "../../../tag/service.js";
    import { assets_kinds } from "../../../asset/assets.api.js";
    import { params, goto } from "@roxi/routify";
    import { format, locale } from "svelte-i18n";
    import { token } from "../../../user/user.state.svelte.js";
    import dayjs from "dayjs";

    // --- Vanilla JS Replacements ---
    import TomSelect from "tom-select";
    import "tom-select/dist/css/tom-select.bootstrap5.css";
    import flatpickr from "flatpickr";
    import "flatpickr/dist/flatpickr.css";
    import { Spanish, English } from "flatpickr/dist/l10n/es.js";

    const redirect = $goto;

    let loc = $derived(
        $params.value && $params.value !== "General"
            ? decodeURIComponent($params.value)
            : "",
    );

    let data = $state([]);
    let refresh = $state(false);

    // Active filters driven strictly by the URL
    let currentFilter = $derived($params ? $params : {});

    // SVELTE 5: Local UI state for form inputs before user clicks "Search"
    let filters = $state({
        asset__kind__in: [],
        finding__status__in: [],
        vulnerability__level__in: [],
        vulnerability__id__ilike: "",
        finding_tag_id: "",
        finding__first_discovery_at: "",
        finding__last_discovery_at: "",
    });

    const dateInputs = [
        {
            id: "finding__first_discovery_at",
            name: "finding__first_discovery_at",
            label: $format("components.advancedSearch.findings_created") || "First discovery at",
        },
        {
            id: "finding__last_discovery_at",
            name: "finding__last_discovery_at",
            label: $format("components.advancedSearch.findings_seen") || "Last discovery at",
        },
    ];

    let priorityOptions = [
        { name: $format("vulnerability.severity.critical").charAt(0).toUpperCase() + $format("vulnerability.severity.critical").slice(1), id: "critical" },
        { name: $format("vulnerability.severity.high").charAt(0).toUpperCase() + $format("vulnerability.severity.high").slice(1), id: "high" },
        { name: $format("vulnerability.severity.medium").charAt(0).toUpperCase() + $format("vulnerability.severity.medium").slice(1), id: "medium" },
        { name: $format("vulnerability.severity.low").charAt(0).toUpperCase() + $format("vulnerability.severity.low").slice(1), id: "low" },
        { name: $format("vulnerability.severity.info").charAt(0).toUpperCase() + $format("vulnerability.severity.info").slice(1), id: "info" },
    ];

    let vulKindOptions = [
        { name: $format("vulnerability.kind.ad"), id: "AD-" },
        { name: $format("vulnerability.kind.asvs"), id: "ASVS-" },
        { name: $format("vulnerability.kind.cve"), id: "CVE-" },
        { name: $format("vulnerability.kind.info"), id: "INFO-" },
        { name: $format("vulnerability.kind.leak"), id: "LEAK-" },
        { name: $format("vulnerability.kind.nvt"), id: "NVT-" },
        { name: $format("vulnerability.kind.sve"), id: "SVE-" },
        { name: $format("vulnerability.kind.eol"), id: "EOL-" },
        { name: $format("vulnerability.kind.dmarc"), id: "DMARC-" },
        { name: $format("vulnerability.kind.spf"), id: "SPF-" },
        { name: $format("vulnerability.kind.m365"), id: "M365-" },
        { name: $format("vulnerability.kind.code"), id: "CODE-" },
        { name: $format("vulnerability.kind.custom"), id: "X-" },
    ];

    let statusOptions = [
        { name: $format("finding.status.open"), id: "open" },
        { name: $format("finding.status.accepted"), id: "accepted" },
        { name: $format("finding.status.fixed"), id: "fixed" },
        { name: $format("finding.status.false_positive"), id: "false_positive" },
    ];

    let translatedAssetKinds = $derived(
        assets_kinds.map((opt) => ({
            id: opt.id,
            name: $format(`asset.kind.${opt.id}.singular`)
        }))
    );

    // Sync URL $params to local UI state
    $effect(() => {
        const p = currentFilter;

        const toArray = (val) => val ? (typeof val === "string" ? val.split(",") : val) : [];

        let first_gte = p.finding__first_discovery_at__gte ? dayjs(p.finding__first_discovery_at__gte).format("YYYY/MM/DD") : "";
        let first_lte = p.finding__first_discovery_at__lte ? dayjs(p.finding__first_discovery_at__lte).format("YYYY/MM/DD") : "";
        let last_gte = p.finding__last_discovery_at__gte ? dayjs(p.finding__last_discovery_at__gte).format("YYYY/MM/DD") : "";
        let last_lte = p.finding__last_discovery_at__lte ? dayjs(p.finding__last_discovery_at__lte).format("YYYY/MM/DD") : "";

        filters = {
            asset__kind__in: toArray(p.asset__kind__in),
            finding__status__in: toArray(p.finding__status__in),
            vulnerability__level__in: toArray(p.vulnerability__level__in),
            vulnerability__id__ilike: p.vulnerability__id__ilike || "",
            finding_tag_id: p.finding_tag_id || "",
            finding__first_discovery_at: first_gte && first_lte ? `${first_gte} - ${first_lte}` : "",
            finding__last_discovery_at: last_gte && last_lte ? `${last_gte} - ${last_lte}` : ""
        };
    });

    // --- TomSelect Svelte Action ---
    function tomSelectAction(node, params) {
        let currentValue = JSON.stringify(params.value || []);

        const formatOptions = (opts) => {
            return (opts || []).map((opt) => {
                if (typeof opt === "object" && opt !== null) {
                    return { id: opt.id, name: opt.name || opt.title_es || opt.title || opt.email || opt.id };
                }
                return { id: opt, name: opt };
            });
        };

        const ts = new TomSelect(node, {
            plugins: ["remove_button"],
            maxItems: null,
            valueField: "id",
            labelField: "name",
            searchField: "name",
            options: formatOptions(params.options),
            create: false,
            placeholder: params.placeholder || "Buscar...",
            onChange: (val) => {
                let formattedVal = !val ? [] : Array.isArray(val) ? val : [val];
                currentValue = JSON.stringify(formattedVal);
                params.onChange(formattedVal);
            },
        });

        if (params.value && params.value.length) {
            ts.setValue(params.value, true);
        }

        return {
            update(newParams) {
                params = newParams;
                const newString = JSON.stringify(newParams.value || []);
                if (newString !== currentValue) {
                    currentValue = newString;
                    ts.setValue(newParams.value || [], true);
                }
            },
            destroy() {
                ts.destroy();
            }
        };
    }

    function flatpickrRangeAction(node, params) {
        let currentValue = params.value || "";

        const fp = flatpickr(node, {
            mode: "range",
            dateFormat: "Y/m/d",
            locale: $locale === "es" ? Spanish : English,
            defaultDate: params.value ? params.value.split(" - ") : [],
            onChange: (selectedDates) => {
                // Force strict manual formatting to avoid Spanish " a " or English " to " strings
                if (selectedDates.length === 2) {
                    const formatDate = (d) => {
                        let y = d.getFullYear();
                        let m = String(d.getMonth() + 1).padStart(2, "0");
                        let day = String(d.getDate()).padStart(2, "0");
                        return `${y}/${m}/${day}`;
                    };

                    const internalValue = `${formatDate(selectedDates[0])} - ${formatDate(selectedDates[1])}`;
                    currentValue = internalValue;
                    params.onChange(internalValue);
                } else if (selectedDates.length === 0) {
                    currentValue = "";
                    params.onChange("");
                }
            },
            onClose: (selectedDates, dateStr, instance) => {
                if (selectedDates.length === 1) {
                    instance.clear();
                    currentValue = "";
                    params.onChange("");
                }
            },
        });

        return {
            update(newParams) {
                params = newParams;
                if (fp.isOpen) return;

                if (newParams.value === currentValue) return;
                currentValue = newParams.value || "";

                if (newParams.value) {
                    fp.setDate(newParams.value.split(" - "), false);
                } else {
                    fp.clear(false);
                }
            },
            destroy() {
                fp.destroy();
            },
        };
    }

    const getTags = async () => await tagService.search("v2/tag/", {});

    const handleEmptyFilters = (filtersObj = {}) => {
        const clean = {};
        for (let [key, val] of Object.entries(filtersObj)) {
            if (val !== "" && val !== null && val !== undefined) {
                clean[key] = val;
            }
        }
        return clean;
    };

    const handleFindingFilters = () => {
        let returnValue = {};
        if (currentFilter.finding_tag_id) returnValue.tag_id = currentFilter.finding_tag_id;
        if (currentFilter.asset__kind__in) returnValue.asset__kind__in = currentFilter.asset__kind__in;
        if (currentFilter.finding__status__in) returnValue.status__in = currentFilter.finding__status__in;
        if (currentFilter.vulnerability__level__in) returnValue.vulnerability__level__in = currentFilter.vulnerability__level__in;
        if (currentFilter.vulnerability__id__ilike) returnValue.vulnerability__id__ilike = currentFilter.vulnerability__id__ilike;
        if (currentFilter.finding__first_discovery_at__gte) returnValue.first_discovery_at__gte = currentFilter.finding__first_discovery_at__gte;
        if (currentFilter.finding__first_discovery_at__lte) returnValue.first_discovery_at__lte = currentFilter.finding__first_discovery_at__lte;
        if (currentFilter.finding__last_discovery_at__gte) returnValue.last_discovery_at__gte = currentFilter.finding__last_discovery_at__gte;
        if (currentFilter.finding__last_discovery_at__lte) returnValue.last_discovery_at__lte = currentFilter.finding__last_discovery_at__lte;
        return returnValue;
    };

    let findingFilters = $derived.by(() => handleFindingFilters());

    function handleFilterChange() {
        let updatedFilter = { ...$params };

        if (filters.asset__kind__in && filters.asset__kind__in.length > 0) {
            updatedFilter.asset__kind__in = filters.asset__kind__in.join(",");
        } else {
            delete updatedFilter.asset__kind__in;
        }

        if (filters.finding__status__in && filters.finding__status__in.length > 0) {
            updatedFilter.finding__status__in = filters.finding__status__in.join(",");
        } else {
            delete updatedFilter.finding__status__in;
        }

        if (filters.vulnerability__level__in && filters.vulnerability__level__in.length > 0) {
            updatedFilter.vulnerability__level__in = filters.vulnerability__level__in.join(",");
        } else {
            delete updatedFilter.vulnerability__level__in;
        }

        if (filters.vulnerability__id__ilike) {
            updatedFilter.vulnerability__id__ilike = filters.vulnerability__id__ilike;
        } else {
            delete updatedFilter.vulnerability__id__ilike;
        }

        if (filters.finding_tag_id) {
            updatedFilter.finding_tag_id = filters.finding_tag_id;
        } else {
            delete updatedFilter.finding_tag_id;
        }

        // Date processing
        if (filters.finding__first_discovery_at && filters.finding__first_discovery_at.includes(" - ")) {
            let dates = filters.finding__first_discovery_at.split(" - ");
            updatedFilter.finding__first_discovery_at__gte = dates[0].replaceAll("/", "-") + "T00:00:00.000-03:00";
            updatedFilter.finding__first_discovery_at__lte = dates[1].replaceAll("/", "-") + "T23:59:59.999-03:00";
            delete updatedFilter.finding__first_discovery_at;
        } else {
            delete updatedFilter.finding__first_discovery_at__gte;
            delete updatedFilter.finding__first_discovery_at__lte;
        }

        if (filters.finding__last_discovery_at && filters.finding__last_discovery_at.includes(" - ")) {
            let dates = filters.finding__last_discovery_at.split(" - ");
            updatedFilter.finding__last_discovery_at__gte = dates[0].replaceAll("/", "-") + "T00:00:00.000-03:00";
            updatedFilter.finding__last_discovery_at__lte = dates[1].replaceAll("/", "-") + "T23:59:59.999-03:00";
            delete updatedFilter.finding__last_discovery_at;
        } else {
            delete updatedFilter.finding__last_discovery_at__gte;
            delete updatedFilter.finding__last_discovery_at__lte;
        }

        const cleanFilters = handleEmptyFilters(updatedFilter);
        redirect("./", { value: $params.value || "General", ...cleanFilters });
    }

    const clearFilters = () => {
        filters = {
            asset__kind__in: [],
            finding__status__in: [],
            vulnerability__level__in: [],
            vulnerability__id__ilike: "",
            finding_tag_id: "",
            finding__first_discovery_at: "",
            finding__last_discovery_at: "",
        };
        redirect("./", { value: $params.value || "General" });
    };

    const clearDateFilter = (fieldName) => {
        filters[fieldName] = "";
    };

    let columns = [
        {
            key: "kind",
            title: $format("list.columns.kind"),
            filterable: false,
            parseAs: "component",
            dataComponent: PropKindRow,
        },
        {
            key: "name",
            title: $format("list.columns.name"),
            filterable: false,
            parseAs: "unsafe-html",
        },
        {
            key: "value",
            title: $format("list.columns.value"),
            filterable: false,
            parseAs: "component",
            dataComponent: PropValueRow,
        },
        {
            key: "finding_name",
            title: $format("list.columns.finding"),
            filterable: false,
            parseAs: "unsafe-html",
            userFunctions: { customSort: ipAdressesCustomComparator },
        },
        {
            key: "vulnerability_kind",
            title: $format("list.columns.vulnerability_kind"),
            filterable: false,
            parseAs: "unsafe-html",
        },
    ];

    const getVulnerabilityKind = (vulnerability) => {
        let str = vulnerability.id.split("-")[0];
        let idx = vulnerabilityService.kinds.findIndex((item) => item.id == str);
        return idx;
    };

    const parseRows = (pageContent) => {
        for (let row of pageContent) {
            row.value = {
                kind: row.kind,
                value: row.value,
                target_object_type: "finding",
                name: row.name,
                max_chars: 70,
            };
            if (row["kind"]) {
                row["kind"] = { kind: row.kind, target_object_type: "finding" };
            }
            if (row["name"]) {
                row["name"] =
                    `<a href="/property/finding/${encodeURIComponent(row.kind.kind)}/${encodeURIComponent(row.name)}">` +
                    row.name +
                    "</a>";
            }
            if (row["finding_name"]) {
                row["finding_name"] =
                    `<a href='/finding/${row["finding_id"]}' title="Ver">${row.finding_name}</a>`;
            }
            if (row["finding_kind"]) {
                row["finding_kind"] = findingService.translations.singular[row.finding_kind];
            }
            if (row["vulnerability_kind"]) {
                row["vulnerability_kind"] =
                    `<a href='/vulnerability?id__ilike=${row.vulnerability_kind.split(" ")[0]}' title="Ver">${row.vulnerability_kind}</a>`;
            }
        }
        return pageContent;
    };

    const getData = async (_filter, _loc, _refresh) => {
        if (!token.access_token) return { data: [], propsByKind: [], propsByKindAndName: [] };

        let dataConfig = handleEmptyFilters({
            ...currentFilter,
            location: loc,
        });
        if (dataConfig.value) {
            delete dataConfig.value;
        }
        let properties = await findingService.search("v2/finding-property", {
            filter: dataConfig,
        });
        data = properties || [];

        let findingsConfig = handleEmptyFilters({ ...findingFilters });
        if (findingsConfig.value) {
            delete findingsConfig.value;
        }
        let findingsResult = await findingService.search("v2/finding/", {
            filter: findingsConfig,
        });

        let propsByKind = groupPropsByKind(data);
        let propsByKindAndName = groupPropsByKindAndName(data);

        let items = JSON.parse(JSON.stringify(data));
        let vulnerabilities = await getVulnerabilities();

        for (let item of items) {
            let finding = findingsResult.find((f) => f.id === item.finding_id);
            let vulnerability = vulnerabilities.find((v) => v.id === finding?.vulnerability_id);

            if (finding) item.finding_kind = finding.kind;
            if (vulnerability) {
                item.finding_name = vulnerability.title_es || vulnerability.title;
                item.vulnerability_kind = getVulnerabilityKind(vulnerability) > -1
                    ? vulnerabilityService.kinds[getVulnerabilityKind(vulnerability)].label
                    : "";
            }
            item.location = item.location && item.location != "" ? item.location : "General";
        }
        return {
            data: items,
            propsByKind: propsByKind,
            propsByKindAndName: propsByKindAndName,
        };
    };

    const getVulnerabilities = async () => {
        return await vulnerabilityService.search("v2/vulnerability/", {});
    };

    const groupPropsByKind = (props) => {
        let groupedProps = props.reduce((a, b) => {
            const found = a.find((e) => e.kind == b.kind);
            return (
                found
                    ? found.finding_id.push(b.finding_id)
                    : a.push({ ...b, finding_id: [b.finding_id] }),
                a
            );
        }, []);
        for (let prop of groupedProps) {
            let count = new Set(prop.finding_id);
            prop.finding_id = Array.from(count);
            prop.count = prop.finding_id.length;
        }
        return groupedProps;
    };

    const groupPropsByKindAndName = (props) => {
        let groupedProps = props.reduce((a, b) => {
            const found = a.find((e) => e.kind == b.kind && e.name == b.name);
            return (
                found
                    ? found.finding_id.push(b.finding_id)
                    : a.push({ ...b, finding_id: [b.finding_id] }),
                a
            );
        }, []);
        for (let prop of groupedProps) {
            let count = new Set(prop.finding_id);
            prop.finding_id = Array.from(count);
            prop.count = prop.finding_id.length;
            prop.label = prop.kind + " - " + prop.name;
        }
        return groupedProps;
    };
</script>

<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    {`${$format("page.properties.finding_props_loc")} ${loc || "General"}`}
                </h1>
            </div>
            <div class="col-6">
                <BreadCrumNav
                    routes={[
                        {
                            label: $format("page.properties.finding_props"),
                            path: "/property/finding",
                        },
                        { label: $format("page.properties.finding_props") },
                    ]}
                />
            </div>
        </div>
    </div>
</section>

<section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 d-flex w-100">
                <div class="card mt-3 card-secondary card-outline no-export col-12 w-100">
                    <div class="card-header">
                        <h4 class="card-title">
                            {$format("components.advancedSearch.search")}
                        </h4>
                    </div>
                    <div class="card-body pe-5">
                        <div class="row mb-3">
                            <div class="col-12 col-md-4">
                                <label for="vulnerability__level__in" class="form-label text-muted fw-bold mb-1" style="font-size: 0.85rem;">
                                    {$format("vulnerability.severity.title")}
                                </label>
                                <select
                                    id="vulnerability__level__in"
                                    name="vulnerability__level__in"
                                    multiple
                                    use:tomSelectAction={{
                                        options: priorityOptions,
                                        value: filters.vulnerability__level__in,
                                        placeholder: $format("buttons.search"),
                                        onChange: (val) => (filters.vulnerability__level__in = val),
                                    }}
                                ></select>
                            </div>
                            <div class="col-12 col-md-4">
                                <label for="vulnerability__id__ilike" class="form-label text-muted fw-bold mb-1" style="font-size: 0.85rem;">
                                    {$format("components.advancedSearch.vulnerability_kind")}
                                </label>
                                <select
                                    class="form-select"
                                    name="vulnerability__id__ilike"
                                    bind:value={filters.vulnerability__id__ilike}
                                >
                                    <option value="">--</option>
                                    {#each vulKindOptions as opt}
                                        <option value={opt.id}>{opt.name}</option>
                                    {/each}
                                </select>
                            </div>
                            <div class="col-12 col-md-4">
                                {#await getTags()}
                                    <label for="finding_tag_id" class="form-label text-muted fw-bold mb-1" style="font-size: 0.85rem;">
                                        {$format("components.advancedSearch.finding_tag")}
                                    </label>
                                    <select class="form-select" disabled>
                                        <option value="">--</option>
                                    </select>
                                {:then tags}
                                    <label for="finding_tag_id" class="form-label text-muted fw-bold mb-1" style="font-size: 0.85rem;">
                                        {$format("components.advancedSearch.finding_tag")}
                                    </label>
                                    <select
                                        class="form-select"
                                        name="finding_tag_id"
                                        bind:value={filters.finding_tag_id}
                                    >
                                        <option value="">--</option>
                                        {#each tags as opt}
                                            <option value={opt.id}>{opt.name}</option>
                                        {/each}
                                    </select>
                                {/await}
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-12 col-md-6">
                                <label for="asset__kind__in" class="form-label text-muted fw-bold mb-1" style="font-size: 0.85rem;">
                                    {$format("components.advancedSearch.asset_kind")}
                                </label>
                                <select
                                    id="asset__kind__in"
                                    name="asset__kind__in"
                                    multiple
                                    use:tomSelectAction={{
                                        options: translatedAssetKinds,
                                        value: filters.asset__kind__in,
                                        placeholder: $format("buttons.search"),
                                        onChange: (val) => (filters.asset__kind__in = val),
                                    }}
                                ></select>
                            </div>
                            <div class="col-12 col-md-6">
                                <label for="finding__status__in" class="form-label text-muted fw-bold mb-1" style="font-size: 0.85rem;">
                                    {$format("components.advancedSearch.status_of_findings")}
                                </label>
                                <select
                                    id="finding__status__in"
                                    name="finding__status__in"
                                    multiple
                                    use:tomSelectAction={{
                                        options: statusOptions,
                                        value: filters.finding__status__in,
                                        placeholder: $format("buttons.search"),
                                        onChange: (val) => (filters.finding__status__in = val),
                                    }}
                                ></select>
                            </div>
                        </div>

                        <div class="row mb-3">
                            {#each dateInputs as field}
                                <div class="col-12 col-md-6">
                                    <div class="d-flex justify-content-between align-items-center mb-1">
                                        <label for={field.id} class="form-label text-muted fw-bold mb-0" style="font-size: 0.85rem;">
                                            {field.label}
                                        </label>
                                        <a
                                            href="#"
                                            class="text-danger text-decoration-none"
                                            style="font-size: 0.75rem;"
                                            onclick={(e) => {
                                                e.preventDefault();
                                                clearDateFilter(field.name);
                                            }}
                                        >
                                            {$format("clean")}
                                        </a>
                                    </div>
                                    <div class="input-group mt-1">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <i class="far fa-calendar-alt"></i>
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            class="form-control float-end daterange cursor-pointer"
                                            id={field.id}
                                            name={field.name}
                                            placeholder="YYYY/MM/DD - YYYY/MM/DD"
                                            readonly
                                            use:flatpickrRangeAction={{
                                                value: filters[field.name],
                                                onChange: (val) => (filters[field.name] = val),
                                            }}
                                        />
                                    </div>
                                </div>
                            {/each}
                        </div>
                        <div class="btn-strip pt-3 mt-3 border-top pb-3">
                            <button class="btn btn-primary btn-sm px-4 me-2" onclick={handleFilterChange}>
                                <i class="fas fa-search me-1"></i> {$format("buttons.search")}
                            </button>
                            <button class="btn btn-light btn-sm px-4 border" onclick={clearFilters}>
                                <i class="fas fa-eraser me-1"></i> {$format("buttons.reset")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {#key refresh + JSON.stringify(currentFilter)}
            {#await getData(currentFilter, loc, refresh)}
                <div class="card mt-3 w-100" style="min-height: 500px;">
                    <div class="card-body" style="display: flex; justify-content: center;">
                        <div class="overlay">
                            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                        </div>
                    </div>
                </div>
            {:then data}
                <div class="row">
                    <div class="col-12 d-flex flex-wrap flex-md-nowrap w-100" style="gap: 15px;">
                        <div class="card mt-3 w-100" style="flex: 1;">
                            <div class="card-header">
                                <div class="card-title">
                                    {$format("page.properties.findings_per_prop_kind")}
                                </div>
                            </div>
                            <div class="card-body">
                                {#if data.data.length > 0}
                                    <CountByPropValue
                                        data={data.propsByKind}
                                        field={"kind"}
                                    />
                                {:else}
                                    <CountByPropValue
                                        data={[]}
                                        field={"kind"}
                                    />
                                {/if}
                            </div>
                        </div>
                        <div class="card mt-3 w-100" style="flex: 1;">
                            <div class="card-header">
                                <div class="card-title">
                                    {$format("page.properties.findings_per_prop_kind_name")}
                                </div>
                            </div>
                            <div class="card-body">
                                {#if data.data.length > 0}
                                    <CountByPropValue
                                        data={data.propsByKindAndName}
                                        field={"name"}
                                    />
                                {:else}
                                    <CountByPropValue
                                        data={[]}
                                        field={"name"}
                                    />
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 w-100">
                        <section class="content px-0">
                            <div class="container-fluid px-0">
                                <div class="row">
                                    <div class="col-12 w-100">
                                        <!-- Custom Event Dispatcher kept to on:refresh to maintain compatibility with child component -->
                                        <PropertiesList
                                            data={data.data}
                                            {columns}
                                            exportsName="Propiedades-de-activo-por-ubicacion"
                                            parseFunc={parseRows}
                                            on:refresh={() => (refresh = !refresh)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            {/await}
        {/key}
    </div>
</section>

<style>
    /* Bootstrap 5 theme overrides for TomSelect tags */
    :global(.ts-control) {
        border-radius: 0.375rem !important;
        padding: 0.375rem 0.75rem !important;
        min-height: 38px !important;
    }

    :global(.ts-wrapper) {
        z-index: 100;
    }

    .cursor-pointer {
        cursor: pointer !important;
    }
</style>